const e = ["pricing-rule"], d = {
  all: e,
  details: () => [...e, "detail"],
  detail: (i) => [...e, "detail", i],
  bidRanges: () => [...e, "bid-range"],
  bidRange: (i, a) => [
    ...e,
    "bid-range",
    i,
    a
  ]
};
export {
  d as pricingRuleKeys
};
//# sourceMappingURL=pricing-rule-keys.js.map
